import React from 'react';

import * as styles from './cta-container.module.css';
import { AlmaLink } from '../alma-link';

export function CtaContainer({ ctas }) {
    return (
        <>
            {ctas && (
                <div className={styles.ctaContainer}>
                    {ctas.map((cta, key) => {
                        return (
                            <AlmaLink
                                cta={cta}
                                key={key}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
}